<div
  class="fixed top-0 left-0 right-0 z-50 bg-gray-100 border-b border-gray-200 shadow-md px-4 py-3 flex justify-end items-center">
  <app-language-selector [translationEnabled]="product$()?.translationEnabled ?? false"></app-language-selector>
</div>

@if (isLoaderVisible()) {
<!-- Show loader while processing -->
<app-loader></app-loader>
} @else {
@if (product$() && !product$()?.productDesignTemplate?.isPublished) {
<div class="max-w-[400px] mx-auto flex items-center justify-center h-[100vh] bg-white pt-16">
  <img src="assets/images/404.gif" alt="404" class="w-[100%] object-cover">
</div>
}
@else if (product$() && product$()?.productDesignTemplate?.publicDisplayUrl) {
<app-loader></app-loader>
}
@else if (product$() && (product$()?.qrProductItem?.recallStatus === 'STARTED' ||
product$()?.qrProductItem?.recallStatus === 'COMPLETED')) {
<app-recall-view [product]="product$()"></app-recall-view>
}
@else if (product$()) {
<div class="max-w-[400px] mx-auto pt-16">
  @for (content of pageContent; track content.id) {
  <section #gaSection class="section-wrapper" [id]="content.slug" [attr.data-ga-section]="content.slug">
    @if (content.slug.startsWith('header')) {
    <app-header [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                  false
                "></app-header>
    } @else if (content.slug.startsWith('text-image-video')) {
    <app-text-image-video [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                  false
                "></app-text-image-video>
    } @else if (content.slug.startsWith('text')) {
    <app-text [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-text>
    } @else if (content.slug.startsWith('carousel')) {
    <app-carousel [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-carousel>
    } @else if (content.slug.startsWith('brand-card')) {
    <app-brand-card [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-brand-card>
    } @else if (content.slug.startsWith('social-links')) {
    <app-social-links [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-social-links>
    } @else if (content.slug.startsWith('video')) {
    <app-video [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-video>
    } @else if (content.slug.startsWith('rate')) {
    <app-rating [isFirstModule]="false" [product]="product$()!" [isLastModule]="false" [content]="content"
      [styles]="content.styles" [isSelectedModule]="
                          false
                        "></app-rating>
    } @else if (content.slug.startsWith('form')) {
    <app-form [isFirstModule]="false" [product]="product$()!" [isLastModule]="false" [content]="content"
      [styles]="content.styles" [isSelectedModule]="
                          false
                        "></app-form>
    } @else if (content.slug.startsWith('email')) {
    <app-email [isFirstModule]="false" [isLastModule]="false" [content]="content" [product]="product$()!"
      [styles]="content.styles" [isSelectedModule]="
                          false
                        "></app-email>
    } @else if (
    content.slug.startsWith('digital-expiration-counter')
    ) {
    <app-digital-expiration-counter [isFirstModule]="false" [isLastModule]="false" [content]="content"
      [styles]="content.styles" [expirationValue]="product$()?.expirationValue" [isSelectedModule]="
                          false
                        "></app-digital-expiration-counter>
    } @else if (content.slug.startsWith('survey')) {
    <app-survey [isFirstModule]="false" [isLastModule]="false" [content]="content" [product]="product$()!"
      [styles]="content.styles" [isSelectedModule]="
                          false
                        "></app-survey>
    } @else if (content.slug.startsWith('track-trace')) {
    <app-track-trace [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-track-trace>
    } @else if (content.slug.startsWith('attributes')) {
    <app-attributes [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-attributes>
    } @else if (content.slug.startsWith('products')) {
    <app-products [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-products>
    } @else if (content.slug.startsWith('footer')) {
    <app-footer [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                          false
                        "></app-footer>
    }
    @else if (content.slug.startsWith('qr')) {
    <app-qr-code [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                    false
                  "></app-qr-code>
    }
    @else if (content.slug.startsWith('authenticity')) {
    <app-authenticity [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                    false
                  "></app-authenticity>
    }
    @else if (content.slug.startsWith('downloadable-files')) {
    <app-downloadable-files [isFirstModule]="false" [isLastModule]="false" [content]="content" [styles]="content.styles"
      [isSelectedModule]="
                    false
                  "></app-downloadable-files>
    }
  </section>
  }
</div>
}
@else {
<app-loader></app-loader>
}
}

@if (!isProcessing$() && product$()) {
<!-- Chart.js (ng2-charts) charts for weight, temperature, and humidity -->
<div *ngIf="weightChartData && weightChartData.labels && weightChartData.labels.length && tenantId === 'shepeherd'"
  class="relative p-[10px] border-2 border-solid border-transparent rounded-[10px] transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-full max-w-[400px] mx-auto mb-6">
  <div class="text-center text-md font-bold mb-2">Weight History</div>
  <canvas baseChart [data]="weightChartData" [options]="weightChartOptions" [type]="'line'">
  </canvas>
</div>

<div *ngIf="tempChartData && tempChartData.labels && tempChartData.labels.length && tenantId === 'shepeherd'"
  class="relative p-[10px] border-2 border-solid border-transparent rounded-[10px] transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-full max-w-[400px] mx-auto mb-6">
  <div class="text-center text-md font-bold mb-2">Temperature History</div>
  <canvas baseChart [data]="tempChartData" [options]="tempChartOptions" [type]="'line'">
  </canvas>
</div>

<div *ngIf="humChartData && humChartData.labels && humChartData.labels.length && tenantId === 'shepeherd'"
  class="relative p-[10px] border-2 border-solid border-transparent rounded-[10px] transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-full max-w-[400px] mx-auto mb-6">
  <div class="text-center text-md font-bold mb-2">Humidity History</div>
  <canvas baseChart [data]="humChartData" [options]="humChartOptions" [type]="'line'">
  </canvas>
</div>
}

@if (showLocationPopover && !isLoaderVisible()) {
<div class="fixed inset-0 z-[10050] bg-[#F4F6FB] flex items-center justify-center px-5 py-8 overflow-y-auto">
  <div class="w-full max-w-[380px] bg-white rounded-3xl shadow-xl px-6 py-8 flex flex-col items-center">
    <div
      class="w-20 h-20 rounded-full flex items-center justify-center mb-5"
      [class.bg-blue-50]="locationStep === 'ask' || locationStep === 'waiting'"
      [class.bg-amber-50]="locationStep === 'blocked' || locationStep === 'unavailable'">
      @if (locationStep === 'waiting') {
      <svg class="location-spinner w-10 h-10 text-blue-600" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.2"></circle>
        <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
      </svg>
      } @else {
      <svg class="w-10 h-10" [class.text-blue-600]="locationStep === 'ask'"
        [class.text-amber-500]="locationStep !== 'ask'" fill="none" stroke="currentColor" viewBox="0 0 24 24"
        aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z">
        </path>
      </svg>
      }
    </div>

    @if (locationStep === 'ask') {
    <h2 class="text-2xl font-bold text-gray-900 text-center mb-3">Turn on location</h2>
    <p class="text-lg text-gray-600 text-center leading-relaxed mb-5">
      We need to know where you are so we can show the right product information.
    </p>

    <button type="button" (click)="enableLocation()"
      class="w-full min-h-[56px] rounded-2xl bg-[#3B43FD] text-white text-xl font-bold shadow-md border-none cursor-pointer">
      Turn On Location
    </button>
    <p class="text-base text-gray-500 text-center mt-4 mb-2 leading-relaxed">
      @if (device === 'android') {
      A message will appear. Tap the <strong class="text-gray-800">top</strong> button.
      } @else {
      A message will appear. Tap <strong class="text-gray-800">Allow</strong>.
      }
    </p>
    <button type="button" (click)="continueWithoutLocation()"
      class="text-base text-gray-500 underline bg-transparent border-none cursor-pointer py-3">
      Skip for now
    </button>
    }

    @if (locationStep === 'waiting') {
    <h2 class="text-2xl font-bold text-gray-900 text-center mb-3">Please wait</h2>
    <p class="text-lg text-gray-600 text-center leading-relaxed">
      Finding your location
    </p>
    }

    @if (locationStep === 'blocked') {
    <h2 class="text-2xl font-bold text-gray-900 text-center mb-3">Location is off</h2>
    <p class="text-lg text-gray-600 text-center leading-relaxed mb-6">
      Please turn it on. Follow these steps:
    </p>

    <ol class="w-full space-y-3 mb-7 p-0 list-none">
      @if (device === 'ios') {
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">1</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Open the <strong>Settings</strong> app on your phone</p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">2</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Scroll down and tap <strong>{{ browserName }}</strong></p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">3</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">
          Tap <strong>Location</strong>, then tap
          <strong>{{ browserName === 'Safari' ? 'Allow' : 'While Using the App' }}</strong>
        </p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">4</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Come back here and tap the button below</p>
      </li>
      } @else if (device === 'android') {
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">1</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">
          Tap the <strong>lock</strong> or <strong>tune</strong> icon at the top of the screen
          <span class="inline-flex items-center gap-1 ml-1 align-middle">
            <span class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-white border border-gray-200"
              aria-hidden="true">
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
                </path>
              </svg>
            </span>
            <span class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-white border border-gray-200"
              aria-hidden="true">
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4">
                </path>
              </svg>
            </span>
          </span>
        </p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">2</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Tap <strong>Permissions</strong></p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">3</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Turn <strong>Location</strong> on</p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">4</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Come back here and tap the button below</p>
      </li>
      } @else {
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">1</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Click the lock icon next to the website address</p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">2</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Set <strong>Location</strong> to <strong>Allow</strong></p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">3</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Come back here and tap the button below</p>
      </li>
      }
    </ol>

    <button type="button" (click)="enableLocation()"
      class="w-full min-h-[56px] rounded-2xl bg-[#3B43FD] text-white text-xl font-bold shadow-md border-none cursor-pointer mb-3">
      I Turned It On
    </button>
    <button type="button" (click)="refreshPage()"
      class="w-full min-h-[48px] rounded-2xl bg-gray-100 text-gray-800 text-lg font-semibold border-none cursor-pointer mb-3">
      Refresh this page
    </button>
    <button type="button" (click)="continueWithoutLocation()"
      class="text-base text-gray-500 underline bg-transparent border-none cursor-pointer py-2">
      Skip for now
    </button>
    }

    @if (locationStep === 'unavailable') {
    <h2 class="text-2xl font-bold text-gray-900 text-center mb-3">We could not find you</h2>
    <p class="text-lg text-gray-600 text-center leading-relaxed mb-6">
      Turn on Location on your phone, then try again.
    </p>

    <ol class="w-full space-y-3 mb-7 p-0 list-none">
      @if (device === 'ios') {
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">1</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Open the <strong>Settings</strong> app</p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">2</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Tap <strong>Privacy & Security</strong></p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">3</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Turn on <strong>Location Services</strong></p>
      </li>
      } @else {
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">1</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Swipe down from the top of your phone</p>
      </li>
      <li class="flex gap-3 items-start bg-gray-50 rounded-2xl p-3">
        <span
          class="flex-shrink-0 w-8 h-8 rounded-full bg-[#3B43FD] text-white text-base font-bold flex items-center justify-center">2</span>
        <p class="text-base text-gray-800 leading-snug m-0 pt-1">Tap the <strong>Location</strong> icon so it is on</p>
      </li>
      }
    </ol>

    <button type="button" (click)="enableLocation()"
      class="w-full min-h-[56px] rounded-2xl bg-[#3B43FD] text-white text-xl font-bold shadow-md border-none cursor-pointer mb-3">
      Try Again
    </button>
    <button type="button" (click)="continueWithoutLocation()"
      class="text-base text-gray-500 underline bg-transparent border-none cursor-pointer py-2">
      Skip for now
    </button>
    }
  </div>
</div>
}